import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class DossierCategoriesService {
    // ----------------------------------------------------------------------
    // Dossier Categories
    // ----------------------------------------------------------------------
    static getDossierCategories(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`dossier-categories?filter=${qs}`, pageNumber));
    }
    static saveDossierCategory(dto) {
        return lastValueFrom(BaseService.save(`dossier-categories`, dto));
    }
    static deleteDossierCategory(oid) {
        return lastValueFrom(BaseService.delete(`dossier-categories/${oid}`));
    }
    static searchDossierCategoryCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`dossier-categories-combo/${selfId}?search=${qs}`));
    }
}
